var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ticket.soid && _vm.ticket.code !== 0)?_c('div',{staticClass:"view-progress-btn",on:{"click":function($event){return _vm.jumpPage(_vm.ticket.soid)}}},[_vm._v("\n    查看服务进度\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }